// 后端添加了，接口并没有这些值返回，故前端来添加

// 二级目录
export const newMenu2 = [
    // 冲天猴 63
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 9999,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '菜单设置',
        parentID: 63,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/homeMenu',
    },
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 99919,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '快递查询',
        parentID: 63,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/ExpressQuery',
    },
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 88919,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '提现审核',
        parentID: 63,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/withdrawalList',
    },
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 87719,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '话费充值记录',
        parentID: 63,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/telephoneBill',
    },
    // 商城管理
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 99999,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '菜单设置',
        parentID: 49,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/merchantMenu',
    },
    // 系统管理
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 99999,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '版本控制',
        parentID: 52,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/versionControl',
    },
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 99999,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '京西打印机',
        parentID: 52,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/jxPrinter',
    },
    // 营销活动
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 399,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '美团活动信息',
        parentID: 39,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/mtpromotion',
    },
    // 门店管理
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 7846,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '门店签约',
        parentID: 27,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/storeSign',
    },
    // 财务
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 7847,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '收银台',
        parentID: 42,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/checkstand',
    },
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 7848,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '拉卡拉商户',
        parentID: 42,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/storeMerPage',
    },
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 7849,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '结算统计',
        parentID: 42,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/settleStatic',
    },
    {
        children: [],
        color: '',
        createdAt: '2021-01-21T17:21:47+08:00',
        deletedAt: '1970-01-01T00:00:00+08:00',
        id: 7845,
        imgURL: '',
        lastOperator: 'suyl',
        level: 2,
        name: '门店聊天管理',
        parentID: 27,
        type: 0,
        updatedAt: '2021-01-21T17:21:50+08:00',
        url: '/storeMessage',
    }
    
]

// 三级目录
export const newMenu3 = [
    // 商品管理 ==> 京西商品及分类管理
    // {
    //     color: "",
    //     createdAt: "2021-01-27T14:33:30+08:00",
    //     deletedAt: "1970-01-01T00:00:00+08:00",
    //     id: 77,
    //     imgURL: "",
    //     lastOperator: "",
    //     level: 3,
    //     name: "畅销品查询",
    //     parentID: 7,
    //     type: 0,
    //     updatedAt: "2021-01-27T14:33:35+08:00",
    //     url: "/bestSeller"
    // },
    // 门店管理 ==> 抖店门店管理
    // {
    //     children: [],
    //     color: '',
    //     createdAt: '2021-01-21T17:21:47+08:00',
    //     deletedAt: '1970-01-01T00:00:00+08:00',
    //     id: 88919,
    //     imgURL: '',
    //     lastOperator: 'suyl',
    //     level: 3,
    //     name: '批量设置电子围栏',
    //     parentID: 7845,
    //     type: 0,
    //     updatedAt: '2021-01-21T17:21:50+08:00',
    //     url: '/electronicFence',
    // },
    // {
    //     children: [],
    //     color: '',
    //     createdAt: '2021-01-21T17:21:47+08:00',
    //     deletedAt: '1970-01-01T00:00:00+08:00',
    //     id: 88920,
    //     imgURL: '',
    //     lastOperator: 'suyl',
    //     level: 3,
    //     name: '批量创建运费模板',
    //     parentID: 7845,
    //     type: 0,
    //     updatedAt: '2021-01-21T17:21:50+08:00',
    //     url: '/freightTemplate',
    // },
    // {
    //     children: [],
    //     color: '',
    //     createdAt: '2021-01-21T17:21:47+08:00',
    //     deletedAt: '1970-01-01T00:00:00+08:00',
    //     id: 88921,
    //     imgURL: '',
    //     lastOperator: 'suyl',
    //     level: 3,
    //     name: '批量查询与配置门店运力',
    //     parentID: 7845,
    //     type: 0,
    //     updatedAt: '2021-01-21T17:21:50+08:00',
    //     url: '/setRiderInfo',
    // },
    // {
    //     children: [],
    //     color: '',
    //     createdAt: '2021-01-21T17:21:47+08:00',
    //     deletedAt: '1970-01-01T00:00:00+08:00',
    //     id: 88922,
    //     imgURL: '',
    //     lastOperator: 'suyl',
    //     level: 3,
    //     name: '创建抖店仓库',
    //     parentID: 7845,
    //     type: 0,
    //     updatedAt: '2021-01-21T17:21:50+08:00',
    //     url: '/setDdWarehouse',
    // }
]


// 门店管理（27）：
// 抖店门店管理     /ddStoreManager
//     批量设置电子围栏  /electronicFence
//     批量创建运费模板  /freightTemplate
//     批量查询与配置门店运力  /setRiderInfo
//     创建抖店仓库  /setDdWarehouse
// 营销活动（39）：
// 美团活动信息  /mtpromotion
// 系统管理（52）
// 版本控制  /versionControl
// 商城管理（49）
// 菜单设置  /merchantMenu
// 冲天猴管理（63）
// 菜单设置  /homeMenu
// 快递查询  /ExpressQuery
// 提现审核  /withdrawalList
// 话费充值记录  /telephoneBill


// WEBPACK FOOTER //
// ./src/components/menu/menu.js